<header class="my-10">
  <div class="container d-flex justify-content-between align-items-center flex-column flex-lg-row">

    <a [routerLink]="['/home']">
      <img class="seecLogo" src="/assets/common/images/logo-on-dark.png" alt="Seec Logo" />
    </a>

    <nav class="navbar navbar-expand-lg order-last order-lg-0">

      <!-- <button class="" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
        <span class="navbar-toggler-icon"></span>
        </button> -->

      <button class="btn p-0 burger-icon burger-icon-left mr-4" (click)="isMenuCollapsed = !isMenuCollapsed">
        <span></span>
      </button>


      <div class="collapse navbar-collapse" [collapse]="isMenuCollapsed">
        <ul class="navbar-nav w-100 pr-0">
          <li class="nav-item">
            <a class="nav-link stroke" [routerLink]="['/home']" routerLinkActive="router-link-active"
              [routerLinkActiveOptions]="{ exact: true }">الرئيسية <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link stroke" [routerLink]="['/about']" routerLinkActive="router-link-active">عن البرنامج</a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link stroke" [routerLink]="['/goals']" routerLinkActive="router-link-active">الأهداف</a>
          </li> -->
          <li class="nav-item">
            <a class="nav-link stroke" [routerLink]="['/awareness']" routerLinkActive="router-link-active">التوعية</a>
          </li>
          <li class="nav-item">
            <a class="nav-link stroke" [routerLink]="['/training']" routerLinkActive="router-link-active">التدريب </a>
          </li>
          <li class="nav-item dropdown" dropdown>
            <a href="javascript:;" class="nav-link stroke dropdown-toggle" dropdownToggle (click)="false">المركز
              الإعلامي</a>
            <ul *dropdownMenu class="dropdown-menu">
              <li><a class="dropdown-item" [routerLink]="['/media-center', 'news']">الأخبار</a></li>
              <li><a class="dropdown-item" [routerLink]="['/media-center', 'events']">الفعاليات</a></li>
              <li><a class="dropdown-item" [routerLink]="['/media-center', 'library']">مركز الوسائط</a></li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link stroke" [routerLink]="['/faq']" routerLinkActive="router-link-active">الأسئلة الشائعة</a>
          </li>
          <li class="nav-item">
            <a class="nav-link stroke" [routerLink]="['/knowledge-base']" routerLinkActive="router-link-active">
              مركز
              المعرفة</a>
          </li>
          <li class="nav-item">
            <a class="nav-link stroke" [routerLink]="['/contact-us']" routerLinkActive="router-link-active">تواصل
              معنا</a>
          </li>
        </ul>
      </div>

    </nav>

    <button *ngIf="isNafathLoginEnabled" class="btn btn-lg btn-login font-size-h6 my-5 my-lg-0" (click)="loginWithNafathUrl()">
      تسجيل الدخول عبر
      <img src="/assets/nafath-vector-logo-seeklogo/nafath-seeklogo-2.svg" alt="نفاذ" height="22" class="ml-2" style="vertical-align: middle; background-color: white; border-radius: 3px; padding: 2px 4px;" />
    </button>
    <!-- Fallback while Nafath is down: identification number + OTP -->
    <button *ngIf="!isNafathLoginEnabled" class="btn btn-lg btn-login font-size-h6 my-5 my-lg-0" [routerLink]="['/account/login-with-id']">
      تسجيل الدخول
    </button>
  </div>
</header>
<!-- <div class="inprrogress-development-bg">
  <div class="inprrogress-development-text">
      إطلاق تجريبي
  </div>
</div> -->